import { useFetch } from '@hn-front/utils';
import { COMMON_API } from '../constants/routes';
var useSkills = function () {
    return useFetch(COMMON_API.skills);
};
export { useSkills };
